import { observable } from 'mobx'
import moment from 'moment';

class WebObjednavka {
    public id: number = null;
    public datum: Date = null
    public jmeno: string = null;
    public prijmeni: string = null;
    public email: string = null;
    public telefon: string = null;
    public ulice: string = null;
    public mesto: string = null;
    public psc: string = null;
    public program: string = null;
    public zacatek: string = null;
    public sleva: string = null;
    public poznamka: string = null;

    public clone(): WebObjednavka {
        const newObjednavka: WebObjednavka = new WebObjednavka();
        newObjednavka.loadFromEntity(this);
        return newObjednavka;
    }

    public loadFromJSON(json: any): WebObjednavka {
        this.id = json.id;
        this.datum = moment(json.datum).toDate();
        this.jmeno = json.jmeno;
        this.prijmeni = json.prijmeni;
        this.email = json.email;
        this.telefon = json.telefon;
        this.program = json.program;
        this.zacatek = json.zacatek;
        this.ulice = json.ulice;
        this.mesto = json.mesto;
        this.psc = json.psc;
        this.sleva = json.sleva;
        this.poznamka = json.poznamka;
        return this;
    }

    public loadFromEntity(ent: WebObjednavka): WebObjednavka {
        this.id = ent.id;
        this.datum = ent.datum;
        this.jmeno = ent.jmeno;
        this.prijmeni = ent.prijmeni;
        this.email = ent.email;
        this.telefon = ent.telefon;
        this.program = ent.program;
        this.zacatek = ent.zacatek;
        this.ulice = ent.ulice;
        this.mesto = ent.mesto;
        this.psc = ent.psc;
        this.sleva = ent.sleva;
        this.poznamka = ent.poznamka;
        return this;
    }
}

export default WebObjednavka;


// WEBPACK FOOTER //
// ./src/models/WebObjednavka.tsx